export class Week {
    public DisplayText:string;
    public Value:number;
    public Checked:boolean;
}
